import { render, staticRenderFns } from "./MeliAuthorize.vue?vue&type=template&id=26a3f00e"
import script from "./MeliAuthorize.vue?vue&type=script&lang=js"
export * from "./MeliAuthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports